import {
    conflicts,
    IPlayerDataLocation,
    isDataSetEmpty,
    PlayerDataLocation,
} from 'Utility/DataConflict/DataConflictsHelper';

/**
 * Get conflicting data sets in list
 */
export function getConflictingSets(dataSets: [IPlayerDataLocation, IPlayerDataLocation]): IPlayerDataLocation[] {
    const dataSetA = dataSets[0];
    const dataSetB = dataSets[1];
    const isSetAEmpty = isDataSetEmpty(dataSetA);
    const isSetBEmpty = isDataSetEmpty(dataSetB);

    // If both sets are empty then no conflict
    if (isSetAEmpty && isSetBEmpty) {
        return [];
    }

    // If only one set is empty or if there are conflicts return the data sets
    if (isSetAEmpty || isSetBEmpty || conflicts(dataSetA.playerData, dataSetB.playerData)) {
        return dataSets;
    }

    // If there are no conflicts and lost data exists then create a conflict
    const lostDataSetA = createLostDataSet(dataSetA);
    if (!isDataSetEmpty(lostDataSetA)) {
        return [dataSetA, lostDataSetA];
    }

    // If there are no conflicts and lost data exists then create a conflict
    const lostDataSetB = createLostDataSet(dataSetB);
    if (!isDataSetEmpty(lostDataSetB)) {
        return [dataSetB, lostDataSetB];
    }

    // Don't return any data sets if no conflicts are found
    return [];

    function createLostDataSet(dataSet: IPlayerDataLocation): IPlayerDataLocation {
        return {
            location: PlayerDataLocation.LOST_DATA_RESTORE,
            playerData: dataSet?.playerData?.__lostData ? JSON.parse(dataSet.playerData.__lostData) : null,
        };
    }
}
